import React, { memo } from "react";
import { EllipsisVerticalIcon } from "lucide-react";
import { Button } from "../button";
import { DropdownMenu } from "../../DropdownMenu";
import { ActionsProps } from "./types";

export const Actions: React.FC<ActionsProps> = memo(
  ({ actions, dropdownActions }) => {
    return (
      <div className="flex items-center justify-center gap-x-2.5">
        {actions?.map((action, index) =>
          React.isValidElement(action) ? (
            React.cloneElement(action, { key: `action-${index}` })
          ) : (
            <Button
              key={`action-${(action as { label: string })?.label}-${index}`}
              onClick={(action as { onClick: () => void })?.onClick}
              variant={
                (action as { variant?: string })?.variant || ("outline" as any)
              }
              size="sm"
              className="inline-flex items-center"
            >
              {(action as { icon?: React.ReactNode })?.icon}
              {(action as { label: string })?.label}
            </Button>
          ),
        )}
        {dropdownActions && dropdownActions.length > 0 && (
          <DropdownMenu
            icon={<EllipsisVerticalIcon className="h-4 w-4" />}
            menuItems={dropdownActions}
          />
        )}
      </div>
    );
  },
);
